import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadge = ({ badge }) => {
  return (
    <div className={`relative ${badge?.earned ? '' : 'opacity-50'}`}>
      <div className={`w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full flex items-center justify-center ${
        badge?.earned 
          ? 'bg-gradient-to-br from-amber-400 to-amber-600 shadow-lg' 
          : 'bg-muted border-2 border-dashed border-border'
      }`}>
        <Icon 
          name={badge?.icon} 
          size={32} 
          className="text-white md:w-10 md:h-10 lg:w-12 lg:h-12" 
        />
      </div>
      {badge?.earned && (
        <div className="absolute -top-1 -right-1 w-6 h-6 md:w-7 md:h-7 bg-success rounded-full flex items-center justify-center border-2 border-card">
          <Icon name="Check" size={14} className="text-white" />
        </div>
      )}
      <div className="text-center mt-2">
        <h4 className="text-xs md:text-sm font-medium text-foreground line-clamp-2">
          {badge?.name}
        </h4>
        {badge?.earned && (
          <p className="text-xs text-muted-foreground mt-1">
            {badge?.earnedDate}
          </p>
        )}
      </div>
    </div>
  );
};

export default AchievementBadge;